import { Message, MessageBox } from 'element-ui'

let _common = {}

_common = {
  MessageError: MessageError,
  MessageInfo: MessageInfo,
  MessageSuccess: MessageSuccess,
  MessageWarning: MessageWarning,
  MesssageBoxQuestion: MesssageBoxQuestion,
  MesssageBoxQuestionAddCourse: MesssageBoxQuestionAddCourse,
  MesssageBoxConfirm: MesssageBoxConfirm,
  MessageBoxSuccess: MessageBoxSuccess,
  MessageBoxInfo: MessageBoxInfo,
  MessageBoxError: MessageBoxError,
  msgWaring: msgWaring,
  msgWaringConfirm: msgWaringConfirm
}

export default _common

export function MessageError(text = '错误',) {
  Message({
    message: text,
    type: 'error',
    duration: 3 * 1000
  })
}
export function MessageInfo(text = '取消') {
  Message({
    message: text,
    type: 'info',
    duration: 3 * 1000
  })
}
export function MessageSuccess(text = '成功') {
  Message({
    message: text,
    type: 'success',
    duration: 3 * 1000
  })
}

export function MessageWarning(text = '警告') {
  Message({
    message: text,
    type: 'warning',
    duration: 3 * 1000
  })
}
export function MesssageBoxQuestionAddCourse(text = 'Box询问') {
  return MessageBox.confirm(text, '提示', {
    confirmButtonText: '继续选课',
    cancelButtonText: '去支付',
    type: 'success'
  })
}
export function MesssageBoxQuestion(text = 'Box询问') {
  return MessageBox.confirm(text, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  })
}
export function MesssageBoxConfirm(text = 'Box询问') {
  return MessageBox.confirm(text, '提示', {
    confirmButtonText: '确定',
    type: 'warning'
  })
}

export function MessageBoxSuccess(text = 'Box成功') {
  return MessageBox.confirm(text, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'success'
  })
}

export function MessageBoxInfo(text = 'Box取消') {
  return MessageBox.confirm(text, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'info'
  })
}

export function MessageBoxError(text = 'Box错误') {
  return MessageBox.confirm(text, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'error'
  })
}

//将message改成模态窗口+遮罩层
//注意一定要加then及catch。否则点击遮罩层的时候会报错
export function msgWaring(text = 'Box') {
  MessageBox.confirm(text, '提示', {
    type: 'warning',
    showCancelButton: false,
    showConfirmButton: false
  }).then(() => {
  }).catch(() => {
  })
}
// 模态窗口+遮罩层+确认按钮
export function msgWaringConfirm(text = 'Box') {
  return MessageBox.confirm(text, '提示', {
    type: 'warning',
    showClose: false,
    closeOnClickModal: false,
    showCancelButton: false,
    showConfirmButton: true
  }).then(() => {
  }).catch(() => {
  })
}